import './validettaLang-tr-TR';
import '../../../node_modules/validetta/src/validetta';
import Swal from 'sweetalert2';
import hook from '../../scripts/utilities/hook';

const validettaForms = document.querySelectorAll(hook('js-validetta'));

validettaForms.forEach(validettaForm => {
  const validettaOptions = {
    realTime: false,
    display: 'bubble',
    bubblePosition: 'bottom',
    errorTemplateClass: 'c-validetta',
    errorClass: 'is-invalid',
    validClass: 'is-valid',
    onValid(event) {
      event.preventDefault();

      setTimeout(() => {
        Swal.fire({
          icon: 'success',
          title: 'Başarılı',
          text: 'Mesajınız başarıyla iletildi!',
        });
      }, 200);

      setTimeout(() => {
        this.form.submit();
      }, 1700);
    },
  };

  // eslint-disable-next-line no-undef, no-new
  new Validetta(validettaForm, validettaOptions);
});
